import React from 'react'
import { PromoButton, PromoButtonInner, PromoButtonLabel } from '../elements'

const Promo = ({ onClick, label, children, dim }) => {
  return (
    <PromoButton onClick={onClick} dim={dim}>
      <PromoButtonInner>
        <PromoButtonLabel>{label}</PromoButtonLabel>
        {children}
      </PromoButtonInner>
    </PromoButton>
  )
}

export default Promo
